import { ChannelManager } from './inc/ChannelManager';
import { AsyncLoader } from './inc/AsyncLoader';
import { ParentEvents } from './inc/ParentEvents';

window.channelManager = new ChannelManager();
window.loader         = new AsyncLoader();
window.parentChannel  = window.channelManager.connect(parent);

const domainRegex = /https?:\/\/[^/]*/i;
const blacklistRegex = /www2\.(mindsquare)\.de/i;

/**
 * An dieser Stelle wird der ChannelManager als Quelle für
 * den dynamischen Loader verwendet.
 */
let syncLocationCallbacks = [];
let syncLocationHref      = null;
window.parentChannel.send(ParentEvents.ParentUrl).then((response) => {
	syncLocationHref = response.match(domainRegex)[0];
	if (syncLocationCallbacks.length <= 0) {
		return;
	}

	syncLocationCallbacks.forEach((syncLocationCallback) => {
		syncLocationCallback(syncLocationHref);
	});
});
setTimeout(() => {
	if (syncLocationHref !== null) {
		return;
	}
	if (syncLocationCallbacks.length <= 0) {
		return;
	}
	
	syncLocationHref = false;
	syncLocationCallbacks.forEach((syncLocationCallback) => {
		syncLocationCallback(false);
	});
}, 1000);
window.loader.pushSource((done) => {
	if (syncLocationHref === null) {
		syncLocationCallbacks.push(done);
	} else {
		done(syncLocationHref);
	}
});

/**
 * An dieser Stelle wird der Post_Link als Quelle für
 * den dynamischen Loader verwendet.
 */
window.loader.pushSource((done) => {
	let frameUrl = '';
	try {
		frameUrl = window.frameElement ? window.frameElement.src : location.href;
	} catch (e) {
		if (e.number !== -2147024891) {
			throw e;
		}
		frameUrl = location.href;
	}

	let postLink = AsyncLoader.getQueryParameter('Post_Link', frameUrl);
	if(!postLink) {
		done(false);
		return;
	}
	let postLinkMatch = postLink.match(domainRegex);
	if (postLinkMatch && !postLinkMatch[0].match(blacklistRegex)) {
		done(postLinkMatch[0]);
	} else {
		done(false);
	}
});

/**
 * An dieser Stelle wird ein Fallback als Quelle für
 * den dynamischen Loader verwendet.
 */
window.loader.pushSource((done) => {
	done('https://mindsquare.de');
});
